import { Icon } from "@nju/icons";
import { Button, Heading, Panel, Separator, Text } from "@nju/ui";

interface ICustomerStatusAddNumberCardProps {
  msisdnCapacity: number | undefined;
  handleRedirectMobile: () => void;
}

export function CustomerStatusAddNumberCard({
  msisdnCapacity,
  handleRedirectMobile,
}: ICustomerStatusAddNumberCardProps) {
  return (
    <div data-cy="sell-mobile-voice-section">
      <Panel
        bgColor="ripeLemon"
        forceShowTitleBlock={true}
        height="full"
        iconColor="currentColor"
        iconName="plus"
        invisibleSeparator={true}
        separatorSize="none"
      >
        <div className="flex flex-col justify-between">
          <div>
            <Separator size="xs" tone="invisible" />
            <Heading font="ttfirs" tone="neutral" variant="h3" weight="bold">
              dodaj kolejny numer
            </Heading>
          </div>
          <Separator size="xs" tone="invisible" />
          <div>
            <Text weight="bold">numery do sprzedania:</Text>
            <Text className="pl-1" weight="bold">
              {msisdnCapacity}
            </Text>
          </div>
          <Separator size="xs" tone="invisible" />
          <div>
            <Button
              display="inlineFlex"
              onPress={handleRedirectMobile}
              size="inline"
              variant="simple"
            >
              <div className="flex gap-3 items-center">
                <Text>sprzedaj</Text>
                <Icon
                  height={18}
                  name="arrow-right"
                  tone="neutral"
                  width={18}
                />
              </div>
            </Button>
          </div>
        </div>
      </Panel>
    </div>
  );
}
